const store = {
  filogixDetails: {
    firmCode: "",
    expertLoginId: "",
    expertProfileNumber: "",
    userId: "",
    subscriberNumber: "",
    subscriberSecurityCode: "",
    subscriberPassword: "",
    licenseRegistrationNumber: "",
    licenseBrokerageNumber: "",
    verified: null
  },
  syncedEmails: {
    syncUrl: "",
    defaultAccountId: "",
    emails: {},
    allIds: []
  },
  syncedCalendars: {
    allIds: [],
    calendars: {}
  },
  overrides: {},
  brokerageData: {},
  brokerageBoards: {},
  isOnThemePreviewMode: false,
  previewModeSource: "",
  brokerageFaq: [],
  personalFaq: [],
  loadingState: false
};
export default store;